
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ameegos",
      function () {
        return require("private-next-pages/ameegos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ameegos"])
      });
    }
  